import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const BasicCourseDetailPanel = ({ title, details, icon }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: "transparent",
        display: "flex",
        height: "68px",
        padding: `${theme.containers.paddingMobile}`,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: theme.customSpacing["sm"],
        flexShrink: 0,
        borderRadius: theme.shape.radius.md,
        border: `1.5px solid ${theme.palette.border.tertiary}`,
        [theme.breakpoints.down("sm")]: {
          flex: "50%"
        },
        "@media (max-width:1080px)": {
          flex: "33%"
        },
                "@media (max-width:1012px)": {
          flex: "33%"
        },
      }}
    >
      <Typography
        sx={{
          color: theme.palette.text.gray,
          fontSize: theme.typography.textXS.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: theme.typography.textXS.lineHeight,
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: theme.customSpacing.sm,
          alignSelf: "stretch",
        }}
      >
        <Box
          sx={{
            width: "16px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
              width: "16px",
              height: "16px",
            },
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            color: theme.palette.text.tertiary,
            fontSize: theme.typography.textSM.fontSize,
            fontWeight: 500,
            lineHeight: theme.typography.textSM.lineHeight,
          }}
        >
          {details}
        </Typography>
      </Box>
    </Paper>
  );
};

export default BasicCourseDetailPanel;
